import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Valence } from '@upright/common/model/types';
import { get, isNil } from 'lodash';
import { legacyRelScoreToDollarsPerYear } from '../monetary-intensity';
import { unitPrices } from './unit-prices';

export function dollarsToPhysicalComparisons(dollars: number, impactCategoryId: ImpactCategoryId, valence: Valence) {
  const units = get(unitPrices, [impactCategoryId, valence], []);
  return units.map(unit => ({
    value: dollars / unit.unitPrice,
    label: unit.label,
    shortLabel: unit.shortLabel,
  }));
}

export function relativeScoreToPhysicalComparisons(
  relativeScore: number,
  impactCategoryId: ImpactCategoryId,
  valence: Valence,
  revenue: number | undefined | null,
) {
  if (isNil(revenue)) {
    // Cannot be computed
    return null;
  }
  const dollarsPerYear = legacyRelScoreToDollarsPerYear(relativeScore, revenue);
  const physicalUnitsPerYear = dollarsToPhysicalComparisons(dollarsPerYear, impactCategoryId, valence);
  return physicalUnitsPerYear;
}
